module.exports = "<input\n  type=\"number\"\n  name=\"{{ vm.name }}\"\n  class=\"form-control\"\n  ng-class=\"vm.className\"\n  ng-attr-placeholder=\"{{ vm.placeholder | translate }}\"\n  ng-model=\"vm.model\"\n  ng-focus=\"vm.focus()\"\n  ng-blur=\"vm.blur()\"\n  ng-change=\"vm.change()\"\n  ng-required=\"vm.isRequired\"\n  ng-disabled=\"vm.disabled\"\n  autocomplete=\"{{ vm.autocomplete }}\"\n  min=\"{{ vm.typeOptions.min }}\"\n  max=\"{{ vm.typeOptions.max }}\">\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-form-control/src/templates/formControl.number.html
// module id = 1487
// module chunks = 12